import { z } from 'zod'
import { containsNewLine } from '@App/helpers/work-entities-fields-validators'
import { IPIValidator } from '@App/helpers/validate'
import writerSchema from '@Entities/schemas/work/writer-schema'
import {
    booleanMessage,
    integerMessage,
    maxNumberMessage,
    newlineMessage,
    nonNegativeMessage,
    numericMessage,
    stringMessage,
    stringSizeMaxMessage,
} from '@Entities/schemas/work/error-messages'
import { PUBLISHER_SHARE_IS_0_ERROR } from '@Const/error-messages'

const publisherSchema = z.object({
    id: z
        .number({ error: numericMessage('ID') })
        .int(integerMessage('Id'))
        .optional()
        .nullable(),
    ipId: z
        .union([z.string({ error: stringMessage('IPID') }), z.number({ error: stringMessage('IPID') })])
        .optional()
        .nullable(),
    localId: z.number({ error: numericMessage('Local ID') }).optional(),
    publisherName: z
        .string({ error: stringMessage('Publisher name') })
        .max(200, stringSizeMaxMessage('Publisher name', 200))
        .refine((val) => !containsNewLine(val), newlineMessage('Publisher name')),
    hfaPublisherNumber: z
        .string({ error: stringMessage('Publisher number') })
        .optional()
        .nullable(),
    ipiNumber: z
        .string()
        .nullable()
        .refine((ipiNumber) => IPIValidator(ipiNumber, false), 'Invalid IPI Number'),
    publisherShare: z
        .number({ error: numericMessage('Publisher share') })
        .nonnegative(nonNegativeMessage('Publisher share'))
        .max(100.06, maxNumberMessage('Publisher share', 100.6))
        .nullable(),
    amend: z
        .boolean({ error: booleanMessage('Amend') })
        .optional()
        .nullable(),
    mailingAddress: z
        .string({ error: stringMessage('Mailing address') })
        .optional()
        .nullable(),
    hfaAgreement: z
        .boolean({ error: booleanMessage('HFA agreement') })
        .optional()
        .nullable(),
})

const originalPublisherSchema = publisherSchema
    .extend({
        administratorPublishers: z.array(publisherSchema),
        writers: z.array(writerSchema),
    })
    .superRefine((schema, ctx) => {
        if (schema.administratorPublishers.length === 0) {
            if (!schema.publisherShare || schema.publisherShare <= 0) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: PUBLISHER_SHARE_IS_0_ERROR,
                    path: ['publisherShare'],
                })
            }
        } else {
            schema.administratorPublishers.forEach((ap, index) => {
                if (!ap.publisherShare || ap.publisherShare <= 0) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: PUBLISHER_SHARE_IS_0_ERROR,
                        path: ['administratorPublishers', index, 'publisherShare'],
                    })
                }
            })
        }
    })

export default originalPublisherSchema
